import { getCurrentUser } from '../../user';

export const getZppAttendances = (state) => {
  const now = new Date();
  const user = getCurrentUser(state);
  const attendances = [...(user?.zppCourseAttendances || [])].filter(
    (attendance) => !!attendance.completedAt && attendance.completedAt <= now
  );

  for (const subscription of user?.subscriptions || []) {
    if (subscription?.subscriptionPlan?.zppCertified) {
      attendances.push(subscription);
    }
  }
  return attendances;
};
